import React, {useEffect, useRef, useState} from "react";

import makeStyles from '@mui/styles/makeStyles';

import config from "../app/config";
import clsx from "clsx";

import {useTranslation} from "react-i18next";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "fit-content",
        backgroundColor: "#fafafa",
        border: "1px solid #444",
        lineHeight: 0,
    },
    rootShadow: {
        boxShadow: theme.shadows[7],
    },
    image: {
        userSelect: "none",
    },
    progress: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#222",
    },
}));

function ImageNative(props) {
    const classes = useStyles();

    const imageElement = useRef(null);
    const rootElement = useRef(null);

    const [loaded, setLoaded] = useState(false);

    const {t, i18n} = useTranslation();

    let imageWidth = config.modules.viewer.image.defaultWidth;
    let imageHeight = config.modules.viewer.image.defaultHeight;

    if (props.size) {
        imageWidth = props.size;
        imageHeight = props.size * config.modules.viewer.image.defaultRatio;
    }

    const loadFinished = () => {
        setLoaded(true);
    };

    return (
        <div className={clsx(['native-img-container', classes.root, props.shadowed && classes.rootShadow])} ref={rootElement}>
            <img src={props.src} loading="lazy" onLoad={loadFinished} className={classes.image} style={{
                width: imageWidth,
                height: !loaded ? imageHeight : "auto",
                position: !loaded ? "absolute" : "inherit",
                maxWidth: imageWidth,
                maxHeight: imageHeight,
            }} ref={imageElement} alt={""}/>
            {!loaded && <div className={classes.progress} style={{
                width: imageWidth,
                height: imageHeight,
            }}>
                <img width={imageWidth} src={"/image/loading.gif"} alt={""}/>
            </div>}
        </div>
    );
}

export default ImageNative;
